import Box from "../../components/Box";
import productImg from "../../assets/product.png";
import Button from "../../components/Button";
import { useState, useEffect } from "react";
import classNames from "classnames";
import { StarIcon } from "@heroicons/react/24/solid";

import variant1img from "./assets/variant1.png";
import variant2img from "./assets/variant2.png";
import variant3img from "./assets/variant3.png";
import variant4img from "./assets/variant4.png";
import variant5img from "./assets/variant5.png";
import variant6img from "./assets/variant6.png";
import variant7img from "./assets/variant7.png";
import variant8img from "./assets/variant8.png";
import { useAppDispatch, useAppSelector } from "../../hooks/reduxHooks";
import { useParams } from "react-router-dom";
import { APP_CONSTANTS } from "../../constants/AppConstants";
import { getCustomizedProductTable } from "../../api/catalog_product.api";
import axios from "axios";
import {
  setFormat,
  setImageQuality,
  setImageSize,
  setSelectDefaultVariant,
} from "../../designer/store/slices/productSlice";

const ProductVariants = ({
  varinatImages,
  setVarinatImages,
  checkedVariants,
  setCheckedVariants,
}: any) => {
  const [mockupFilter, setMockupFilter] = useState("Main Mockup");
  const productImages = useAppSelector((state) => state.product.product_images);
  const dispatch = useAppDispatch();
  const selectedVariantData = useAppSelector(
    (state) => state.product.selected_variant_data
  );
  const imageQuality = useAppSelector((state) => state.product.imageQuality);
  const imageSize = useAppSelector((state) => state.product.imageSize);
  const format = useAppSelector((state) => state.product.format);

  const [customizeTableData, setCustomizeTableData] = useState({
    title: "",
    productImage: "",
  });
  const current_design_data = useAppSelector(
    (state: any) => state.product.current_design_data
  );
  const selected_variant_data = useAppSelector(
    (state: any) => state.product.selected_variant_data
  );
  const defaultVariant = useAppSelector(
    (state: any) => state.product.default_variant
  );

  const params = useParams();
  // const [checkedVariants, setCheckedVariants] = useState([1, 6]);
  // const [checkedMockups, setCheckedMockups] = useState([1]);
  const [variants, setVariants] = useState([
    { id: 1, img: variant1img },
    { id: 2, img: variant2img },
    { id: 3, img: variant3img },
    { id: 4, img: variant4img },
    { id: 5, img: variant5img },
    { id: 6, img: variant6img },
    { id: 7, img: variant7img },
    { id: 8, img: variant8img },
    { id: 11, img: variant1img },
    { id: 22, img: variant2img },
    { id: 33, img: variant3img },
    { id: 44, img: variant4img },
    { id: 55, img: variant5img },
    { id: 66, img: variant6img },
    { id: 77, img: variant7img },
    { id: 88, img: variant8img },
  ]);
  const [imageSeleted, setImageSeleted] = useState<any>([
    { id: 1, img: productImg },
    { id: 2, img: productImg },
  ]);
  const [mockPreview, setMockPreview] = useState<any>(null);

  const handleCheckedVariants = (id: any) => {
    debugger;
    const newVariants = [...checkedVariants];
    if (checkedVariants.includes(id)) {
      const toRemove = newVariants.indexOf(id);
      newVariants.splice(toRemove, 1);
    } else {
      newVariants.push(id);
    }
    setCheckedVariants(newVariants);
  };

  // const handleCheckedMockups = (id: any) => {
  //   const newVariants = [...checkedMockups];
  //   if (checkedMockups.includes(id)) {
  //     const toRemove = newVariants.indexOf(id);
  //     newVariants.splice(toRemove, 1);
  //   } else {
  //     newVariants.push(id);
  //   }
  //   setCheckedMockups(newVariants);
  // };

  const handleMainImage = (id: any) => {
    dispatch(setSelectDefaultVariant(id));
  };

  const handleImagePixel = (e: any) => {
    dispatch(setImageSize(e.target.value));
  };
  const handleImageQuality = (e: any) => {
    debugger;
    console.log(e.target.value);
    dispatch(setImageQuality(e.target.value));
  };

  useEffect(() => {
    // debugger;
    // console.log(selected_variant_data);
    if (varinatImages.length > 0) {
      const newArray = varinatImages.map((item: any) => ({
        id: item.id,
        img: item.src,
        ...item,
      }));
      setVariants(newArray);
    }
  }, [varinatImages]);

  useEffect(() => {
    if (!mockPreview && defaultVariant && selectedVariantData.length > 0) {
      selectedVariantData.map((i: any) => {
        const produtImage = productImages.find(
          (item: any) => item.image_id === i.image_id
        );
        return produtImage && defaultVariant === i.id
          ? setMockPreview({
              ...produtImage,
              img: produtImage.src,
            })
          : null;
      });
    }
  }, [defaultVariant]);

  useEffect(() => {
    if (variants.length > 0) {
      // debugger;
      const mappedData = variants.filter((item) =>
        checkedVariants.includes(item.id)
      );
      // const mappedData_two = variants.find(
      //   (item) => item.id === checkedVariants[checkedVariants.length - 1]
      // );
      // setMockPreview(mappedData_two);
      setImageSeleted(mappedData);
    }
  }, [checkedVariants, variants]);

  useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    // debugger;
    const res = await getCustomizedProductTable(params.productId);
    setCustomizeTableData(res.data);
  };

  const downloadImage = async (img: any) => {
    try {
      const response = await axios.get(img, { responseType: "blob" });
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch image");
    }
  };

  const getImage = (img: any) => {
    console.log(customizeTableData);
    return (
      APP_CONSTANTS.base_url +
      "pod_products/createImage?customizeProductId=" +
      params.productId +
      "&baseImageURL=" +
      encodeURIComponent(img) +
      "&designImageURL=" +
      encodeURIComponent(current_design_data.design_image) +
      "&width=300&height=400&x=300&y=20&quality=" +
      imageQuality +
      "&format=" +
      format +
      "&w=" +
      imageSize +
      "&h=" +
      imageSize
    );
  };

  const createName = (variantName: any) => {
    const baseName = customizeTableData.title;
    const formattedBaseName = baseName.replace(/\s+/g, "-").toLowerCase();
    const formattedVariantName = variantName.replace(/\s+/g, "-").toLowerCase();

    return (formattedBaseName + "-" + formattedVariantName).replace(/-+/g, "-"); // Replace consecutive dashes with a single dash
  };

  const downLoadAllImages = async () => {
    debugger;

    const images = await Promise.all(
      selectedVariantData.map(async (item2: any) => {
        const produtImage = productImages.find(
          (item: any) => item.image_id === item2.image_id
        );
        const imageBlob = await downloadImage(getImage(produtImage.src));
        const imageUrl = URL.createObjectURL(imageBlob);
        debugger;
        return {
          name: createName(item2.title),
          imageUrl: imageUrl,
        };
      })
    );

    images.forEach((imageUrl: any, index: number) => {
      setTimeout(() => {
        const link = document.createElement("a");
        link.href = imageUrl.imageUrl;
        link.setAttribute("download", imageUrl.name + "." + format);
        link.style.display = "none"; // Hide the link
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // Remove the link after clicking
      }, index * 1000); // Adjust the delay as needed (here it's 1000 milliseconds or 1 second)
    });
  };
  return (
    <Box>
      <div className="flex max-md:flex-col items-stretch justify-between gap-5 main-wrapper-container">
        <div className="w-full max-w-[280px] pr-5 border-r max-md:border-r-0 max-md:border-b pb-3 border-solid border-gray-200 wrapper-section1">
          <h3>Product Variants</h3>
          <br />
          <p>Search Different Mockup Styles</p>
          <br />
          <div>
            <div className="flex items-center justify-start mb-3">
              <button
                onClick={() => setMockupFilter("Main Mockup")}
                className={classNames("px-4 py-1 border-b-2", {
                  "border-gray-200": mockupFilter !== "Main Mockup",
                  "border-primaryred text-primaryred":
                    mockupFilter === "Main Mockup",
                })}
              >
                Main Mockup
              </button>
              <button
                onClick={() => setMockupFilter("Additional")}
                className={classNames("px-4 py-1 border-b-2", {
                  "border-gray-200": mockupFilter !== "Additional",
                  "border-primaryred text-primaryred":
                    mockupFilter === "Additional",
                })}
              >
                Additional
              </button>
            </div>
            <div className="mt-6 flex flex-wrap gap-3 max-w-[250px]">
              {mockupFilter === "Main Mockup" &&
                selectedVariantData.map((i: any) => {
                  const produtImage = productImages.find(
                    (item: any) => item.image_id === i.image_id
                  );
                  return produtImage && defaultVariant === i.id ? (
                    <div
                      key={i.id}
                      className={classNames(
                        "relative bg-white border border-gray-200 rounded-md p-1 cursor-pointer",
                        {
                          "border-blue-800": defaultVariant === i.id,
                        }
                      )}
                      onClick={() => {
                        handleMainImage(i.id);
                        handleCheckedVariants(i.id);
                        setMockPreview({
                          ...produtImage,
                          img: produtImage.src,
                        });
                      }}
                    >
                      <img src={produtImage.src} alt="" width={72} />
                    </div>
                  ) : (
                    <></>
                  );
                })}
              {mockupFilter === "Additional" &&
                variants.map((v: any) => (
                  <button
                    key={v.id}
                    className={classNames(
                      "bg-white border border-gray-200 rounded-md p-1",
                      {
                        "border-green-400": checkedVariants.includes(v.id),
                      }
                    )}
                    onClick={() => handleCheckedVariants(v.id)}
                  >
                    <img src={v.img} alt="" width={72} />
                  </button>
                ))}
            </div>
          </div>
          <br />
          <hr />
          <br />
          {/* <div className="flex flex-col gap-2">
            <div className="text-lg font-bold">Choose Placements:</div>
            {placements.map((p: any) => (
              <label key={p} className="flex gap-2" htmlFor={p}>
                <input type="checkbox" name="placement" id={p} defaultChecked />
                <span>{p}</span>
              </label>
            ))}
          </div>
          <br />
          <hr />
          <br /> */}
          <h3>Mockup format</h3>
          <br />
          <div className="flex flex-col gap-3 max-w-[280px] leading-4">
            <label className="flex items-center gap-2" htmlFor="jpeg">
              <input
                type="radio"
                name="format"
                id="jpeg"
                value="jpeg"
                checked={format === "jpeg"}
                onChange={() => dispatch(setFormat("jpeg"))}
              />
              <span>JPG (smaller, your store will load faster)</span>
            </label>
            <label className="flex items-center gap-2" htmlFor="png">
              <input
                type="radio"
                name="format"
                id="png"
                value="png"
                checked={format === "png"}
                onChange={() => dispatch(setFormat("png"))}
              />
              <span>PNG (bulkier, but with a transparent background)</span>
            </label>
          </div>
          <div className="mb-5 mt-8">
            <label
              className="block font-bold text-gray-600 mb-1"
              htmlFor="title"
            >
              Image Width (in pixels):
            </label>
            <input
              className="block w-full max-w-[364px] px-4 py-2 bg-gray-50 focus:bg-white rounded-md border border-gray-300"
              type="text"
              id="title"
              defaultValue={imageSize}
              onChange={(e) => handleImagePixel(e)}
            />
          </div>
          <div className="mb-5">
            <label
              className="block font-bold text-gray-600 mb-1"
              htmlFor="title"
            >
              Image Quality:
            </label>
            <p className="text-gray-500 text-xs">
              The higher the DPI the higher the resolution
            </p>

            <div className="relative mb-6">
              <input
                id="labels-range-input"
                type="range"
                min={1}
                max={100}
                defaultValue={imageQuality}
                onChange={(e) => handleImageQuality(e)}
                className="w-full h-2 bg-gray-200 rounded-lg appearance-none cursor-pointer dark:bg-gray-700"
              />
              <span className="text-sm text-gray-500 dark:text-gray-400 absolute start-0 -bottom-6">
                1
              </span>

              <span className="text-sm text-gray-500 dark:text-gray-400 absolute end-0 -bottom-6">
                100
              </span>
            </div>
          </div>
        </div>

        <div className="w-full my-container wrapper-section2 overflow-auto">
          <div className="section section1">
            {" "}
            <h3>Mockup Preview</h3>
            <br />
            {(
              mockPreview && mockPreview.img
                ? mockPreview.img
                : customizeTableData.productImage
            ) ? (
              <img
                className="border border-gray-200"
                width={300}
                src={getImage(
                  mockPreview && mockPreview.img
                    ? mockPreview.img
                    : customizeTableData.productImage
                )}
                alt=""
              />
            ) : (
              <>Please select image for preview</>
            )}
            <br />
          </div>
          <div className="section section2 ">
            <Button type="primary" onClick={downLoadAllImages}>
              Download All Images
            </Button>
            <br />
            <br />
          </div>

          {/* <h3>Select Your Main Image Style</h3> */}

          <div className="flex flex-wrap gap-2 overflow-auto section section3">
            <div className="overflow-x-auto">
              <div className="w-max bg-gray-100 p-3 rounded-lg">
                <div className="flex flex-wrap gap-3">
                  {variants.map((v: any) => (
                    <button
                      key={v.id}
                      className="relative bg-white border border-gray-200 rounded-md p-1"
                      onClick={() => {
                        handleCheckedVariants(v.id);
                        setMockPreview({
                          ...v,
                          img: v.src,
                        });
                      }}
                    >
                      {/* <input
                  type="checkbox"
                  className="w-3 h-3 absolute left-1 top-1 cursor-pointer"
                  checked={checkedVariants.includes(v.id)}
                  onChange={() => handleCheckedVariants(v.id)}
                /> */}
                      <img src={v.img} alt="" width={50} />
                    </button>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <br />

          <div className="section section4">
            {" "}
            <h3>Your Main Product Image</h3>
            <br />
            <div className="overflow-x-auto">
              <div className="w-max bg-gray-100 p-3 rounded-lg">
                <div className="text-xs mb-3">
                  Main image is the first image that appears on your product
                  detail page
                </div>
                <div className="flex flex-wrap gap-3">
                  {selectedVariantData.map((i: any) => {
                    const produtImage = productImages.find(
                      (item: any) => item.image_id === i.image_id
                    );
                    return produtImage && defaultVariant === i.id ? (
                      <div
                        key={i.id}
                        className={classNames(
                          "relative bg-white border border-gray-200 rounded-md p-1 cursor-pointer",
                          {
                            "border-blue-800": defaultVariant === i.id,
                          }
                        )}
                        onClick={() => {
                          handleMainImage(i.id);
                          handleCheckedVariants(i.id);
                          setMockPreview({
                            ...produtImage,
                            img: produtImage.src,
                          });
                        }}
                      >
                        <img src={produtImage.src} alt="" width={72} />
                      </div>
                    ) : (
                      <></>
                    );
                  })}
                </div>
              </div>
            </div>
            <br />
          </div>
          <div className="section section5">
            <h3>
              Select Your Main Image Variant - Which Variant / Color to Display
              First
            </h3>
            <br />
            <div className="overflow-x-auto">
              <div className="w-max bg-gray-100 p-3 rounded-lg">
                <div className="text-xs mb-3">
                  Main image is the first image that appears on your product
                  detail page
                </div>
                <div className="flex flex-wrap gap-3">
                  {selectedVariantData.map((i: any) => {
                    const produtImage = productImages.find(
                      (item: any) => item.image_id === i.image_id
                    );
                    return produtImage ? (
                      <div
                        key={i.id}
                        className={classNames(
                          "relative bg-white border border-gray-200 rounded-md p-1 cursor-pointer",
                          {
                            "border-blue-800": defaultVariant === i.id,
                          }
                        )}
                        onClick={() => {
                          handleMainImage(i.id);
                          setMockPreview({
                            ...produtImage,
                            img: produtImage.src,
                          });
                        }}
                      >
                        {defaultVariant === i.id && (
                          <div className="absolute w-full bg-blue-800 text-center -m-1 text-white text-[10px] font-bold rounded-t-[4px]">
                            <StarIcon className="h-2 w-2 text-white inline -mt-0.5 mr-0.5" />
                            Main Image
                          </div>
                        )}
                        <img src={produtImage.src} alt="" width={72} />
                      </div>
                    ) : (
                      <></>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Box>
  );
};

export default ProductVariants;
